import axios from "axios";
import {
  aiChatUrl,
  authServerUrl,
  authUrl,
  clientId,
  clientSecret,
  gatewayUrl,
  localStorageKeys,
} from "./const";
import { checkAuth } from "./auth/authHelper";

export const getAuthHeader = () => {
  return `${localStorage.getItem(
    localStorageKeys.TOKEN_TYPE,
  )} ${localStorage.getItem(localStorageKeys.ACCESS_TOKEN)}`;
};

const attachAddAuthHeader = async (config) => {
  await checkAuth();
  config.headers["Authorization"] = getAuthHeader();
  config.headers["Company-Profile"] = localStorage.getItem(
    localStorageKeys.USER.CURRENT_COMPANY,
  );
  return config;
};

// For accessing authentication server
export const authServerInstance = axios.create({
  baseURL: authServerUrl,
});

authServerInstance.interceptors.request.use(attachAddAuthHeader);

// For fetching images in doc upload
export const blobInstance = axios.create({
  baseURL: gatewayUrl,
  responseType: "blob",
});

blobInstance.interceptors.request.use(attachAddAuthHeader);

// Api access through gateway (JSON)
export const gatewayInstance = axios.create({
  baseURL: gatewayUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

gatewayInstance.interceptors.request.use(attachAddAuthHeader);

// Api access through gateway (FORM DATA)
export const formDataInstance = axios.create({
  baseURL: gatewayUrl,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
formDataInstance.interceptors.request.use(attachAddAuthHeader);

// Oauth2 Authentication
export const authenticationInstance = axios.create({
  baseURL: authUrl,
  // The token endpoint sits in front of everything else (bootstrap included),
  // so it must never hang indefinitely - axios defaults to no timeout.
  timeout: 20000,
  headers: {
    Authorization: `Basic ${btoa(clientId + ":" + clientSecret)}`,
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

export const aiInstance = axios.create({
  baseURL: aiChatUrl,
  headers: {
    "Content-Type": "application/json",
  },
});
aiInstance.interceptors.request.use(attachAddAuthHeader);
